module.exports = __webpack_public_path__ + "img/H-63-ST-1500-BB.66dfbb70.png";